module.exports = __webpack_public_path__ + "static/media/apple-compressed.27f40f94.jpg";